// Leanbot toolkit bar host glue (workspace-plugins toolkit/README.md "Host contract").
// The bar itself is /_ptv/toolkit/bar.js (index.html). This file only hands it the signed-in user; it never throws and
// it does nothing visible when the bar is missing (404, kill switch, framed page).
export function publishToolkitUser(profile, win = globalThis.window) {
  try {
    if (!win || !profile || !(profile.name || profile.login)) return false;
    const patch = { user: { name: String(profile.name || profile.login), login: String(profile.login || "") } };
    const cfg = win.PTV_TOOLKIT || (win.PTV_TOOLKIT = {});
    Object.assign(cfg, patch);
    win.dispatchEvent(new win.CustomEvent("ptv-toolkit:config", { detail: patch }));
    return true;
  } catch (e) {
    return false;
  }
}
